/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-user-x-ray': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.5 5.625v-1.25h-1.875v-1.25h-1.25v1.25H12.5v1.25h1.875V7.5H12.5v1.25h1.875V10h1.25V8.75H17.5V7.5h-1.875V5.625H17.5zm1.875-3.75h-8.75A.625.625 0 0010 2.5v8.125c0 .345.28.625.625.625h8.75c.345 0 .625-.28.625-.625V2.5a.625.625 0 00-.625-.625zM17.5 5.625h-1.875V7.5H17.5v1.25h-1.875V10h-1.25V8.75H12.5V7.5h1.875V5.625H12.5v-1.25h1.875v-1.25h1.25v1.25H17.5v1.25zM9.375 18.75h-1.25v-2.5a1.841 1.841 0 00-1.875-1.875h-2.5a1.841 1.841 0 00-1.875 1.875v2.5H.625v-2.5a3.094 3.094 0 013.125-3.125h2.5a3.094 3.094 0 013.125 3.125v2.5zM5 6.875a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75zm0-1.25a3.125 3.125 0 100 6.25 3.125 3.125 0 000-6.25z"/>'
  }
})
